import React, { useRef, useState, useEffect } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { ZONES } from "./zonesdata";

export default function AppBar({
  activeZone,
  onSelect,
  onMenuClick,
  theme = "dark",
}) {
  const scrollRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  useEffect(() => {
    const checkScroll = () => {
      if (!scrollRef.current) return;
      setCanScrollLeft(scrollRef.current.scrollLeft > 0);
      setCanScrollRight(
        scrollRef.current.scrollLeft + scrollRef.current.clientWidth <
          scrollRef.current.scrollWidth
      );
    };
    checkScroll();
    scrollRef.current?.addEventListener("scroll", checkScroll);
    window.addEventListener("resize", checkScroll);
    return () => {
      scrollRef.current?.removeEventListener("scroll", checkScroll);
      window.removeEventListener("resize", checkScroll);
    };
  }, []);

  const scrollBy = (amount) =>
    scrollRef.current?.scrollBy({ left: amount, behavior: "smooth" });

  return (
    <nav
      className="
        w-full relative bg-[#0f172a] border-b border-slate-800
        shadow-sm overflow-visible flex items-center justify-center
      "
      style={{ height: "42px", minHeight: "42px" }}
    >
      {/* Scroll buttons */}
      {canScrollLeft && (
        <button
          className="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-black/50 p-1 rounded-full"
          onClick={() => scrollBy(-100)}
        >
          <ChevronLeft className="w-[14px] h-[14px] text-white" />
        </button>
      )}
      {canScrollRight && (
        <button
          className="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-black/50 p-1 rounded-full"
          onClick={() => scrollBy(100)}
        >
          <ChevronRight className="w-[14px] h-[14px] text-white" />
        </button>
      )}

      {/* Scroll area */}
      <div
        ref={scrollRef}
        className="flex overflow-x-auto no-scrollbar gap-6 px-6 py-1 items-center justify-center"
        style={{ scrollBehavior: "smooth" }}
      >
        {ZONES.map((z) => (
          <button
            key={z.key}
            onClick={() => {
              onSelect?.(z.key);
              onMenuClick?.(z.key);
            }}
            className={`
              flex flex-col items-center justify-center min-w-[36px] h-full
              ${activeZone === z.key ? "text-sky-400 font-semibold" : "text-white/80"}
              transition-transform hover:scale-105
            `}
          >
            {/* Centered icon */}
            <div className="flex items-center justify-center h-[20px] mb-[2px]">
              {React.cloneElement(z.icon, {
                size: 12,
                color: z.color,
                className: `transition-all group-hover:scale-110 drop-shadow-sm`,
              })}
            </div>
            {/* Label */}
            <span
              className={`text-[7px] leading-[6rem] font-medium tracking-tight ${
                activeZone === z.key ? "text-sky-300" : "text-slate-300"
              }`}
              style={{
                lineHeight: "0.6rem",
                textShadow:
                  activeZone === z.key
                    ? "0 0 6px rgba(56,189,248,0.8)"
                    : "0 0 3px rgba(0,0,0,0.6)",
              }}
            >
              {z.title}
            </span>
          </button>
        ))}
      </div>
    </nav>
  );
}
